import React from 'react';

import { formatDollar } from '../../../utils/CurrencyFormatter';

const Summations = ({ cost, vat, packageTitle }) => {
  return (
    <div>
      <div className="flex items-center justify-between">
        <p className="text-cf-300 font-header bg-cf-200 p-2">{packageTitle}</p>
        <p>{formatDollar(cost || 0)}</p>
      </div>

      <div className="text-left mt-3 -mb-3 font-header">Includes;</div>
      <ul className="text-left text-sm my-4">
        <li>Farm Inputs & labor</li>
        <li>Farm Insurance</li>
        <li>Crop care</li>
        <li>Farm Manager Support</li>
        <li>Farm services</li>
      </ul>

      <div className="flex items-center justify-between text-left text-sm">
        <div>
          <p>VAT</p>
          <p>Farm Management fee</p>
          <p className="font-header">Total</p>
        </div>

        <div>
          <p>{vat}</p>
          <p>Inclusive</p>
          <p className="font-header">{formatDollar(cost || 0)}</p>
        </div>
      </div>
    </div>
  );
};

export default Summations;
